function cloneMyDate({ day, month, year }) {
  return { day, month, year };
}

export {
  cloneMyDate
};
